import React, { Component } from "react";
import DeleteAccountSection from "./DeleteAccountSection";
import axios from "../../node_modules/axios";
import CryptoJS from "../../node_modules/crypto-js";
import InternalServerError from "./InternalServerError";
import DuplicateRequest from "./DuplicateRequest";
import EmailConfirmation from "./EmailConfirmation";

class DeleteAccountForm extends Component {
  constructor() {
    super();
    this.state = {
      selectedBrand: '7-Eleven',
      reqDetailsCount: 0,
      disabled: true,
      requestForm: true,
      internalServerError: false,
      duplicateRequest: false,
      duplicateRequestMsg: '',
      requestReceived: false,
      formData: {
        firstName: "",
        lastName: "",
        contactEmail: "",
        identifierValue: "",
        requestDetails: "",
      }
    };
  }

  handleSelectBrandChange = (e) => {
    console.log(e.target.value)
    this.setState({
      selectedBrand: e.target.value,
    });
  }

  handleFirstNameChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.firstName = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };
  handleLastNameChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.lastName = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };
  handleEmailChange = (e) => {
    const emailPattern =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (e.target.value.length > 0) {
      this.setState({ emailError: "" });
      if (!emailPattern.test(e.target.value)) {
        this.setState(
          { emailError: "Please enter a valid email.", validEmail: false },
          () => {
            this.validationCheck();
          }
        );
      } else {
        this.setState({ emailError: "", validEmail: true }, () => {
          this.validationCheck();
        });
      }
    } else {
      this.setState({
        emailError: "This field is required.",
        validEmail: false,
      });
    }
    const newFormData = { ...this.state.formData };
    newFormData.contactEmail = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
  };
  handlePhoneChange = (e) => {
    const { value } = e.target;
    console.log('value ', value);
    if (/^\d{0,10}$/.test(value)) {
      const newFormData = { ...this.state.formData };
      newFormData.identifierValue = value;
      this.setState({ formData: newFormData });
    }
    if (value.length > 9) {
      this.setState({ validPhone: true },() => {
          this.validationCheck();
        });
    }
    else {
      this.setState({ validPhone: false },() => {
          this.validationCheck();
        });
    }
  };

  handleRequestDetailsChange = (e) => {
    const newFormData = { ...this.state.formData };
    newFormData.requestDetails = e.target.value.replace(/[\<\>]/g, "");
    this.setState({ formData: newFormData });
    this.setState({ reqDetailsCount: e.target.value.length });
  };

  onSubmitBtnClick = () => {
    this.setState({ disabled: true });

    if (
      this.state.formData.firstName.length > 0 &&
      this.state.formData.lastName.length > 0 &&
      this.state.validEmail &&
      this.state.validPhone
    ) {
      let finalFormData = JSON.parse(JSON.stringify(this.state.formData));
      finalFormData["identifierType"] = 'PHONE_NUMBER';
      finalFormData["requestType"] = this.state.selectedBrand === '7-Eleven' ? 'v2_close_accnt_wf_7-11' : 'v2_close_accnt_wf_speedway';
      console.log('finalFormData ', finalFormData)
      this.submitForm(finalFormData);
    }
  };

  async submitForm(formData) {
    var obj = {
      url: process.env.REACT_APP_DPR_API_URL + "/DSARRequestNew",
      body: CryptoJS.AES.encrypt(
        JSON.stringify(formData),
        this.props.password
      ).toString(),
      method: "POST",
    };
    try {
      const response = await axios({
        url: "/servercall/DPRAPI",
        method: "POST",
        data: obj,
      });
      this.setState({ requestForm: false });
      let bytes = CryptoJS.AES.decrypt(response.data, this.props.password);
      let decryptRes = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      console.log('decryptRes ', decryptRes)
      if (decryptRes.status === "Request Received") {
        this.setState({ requestReceived: true })
      }
      else if (decryptRes.info !== undefined && decryptRes.info.includes("Duplicate")) {
        this.setState({
          duplicateRequest: true,
          duplicateRequestMsg: decryptRes.info,
        });
      }
      else {
        this.setState({ internalServerError: true });
      }
    } catch (e) {
      console.log(e);
      this.setState({ requestForm: false });
      this.setState({ internalServerError: true });
      return e;
    }
  }

  validationCheck() {
    console.log(' this.state.validPhone ', this.state.validPhone)
    if (
      this.state.formData.firstName.length > 0 &&
      this.state.formData.lastName.length > 0 &&
      this.state.validEmail &&
      this.state.validPhone) {
      if (document.getElementById("submit-button")) {
        this.setState({ disabled: false });
      }
    } else {
      if (document.getElementById("submit-button")) {
        this.setState({ disabled: true });
      }
    }
  }

  render() {
    return (
      this.state.requestForm ?
        <div className="main-content">
          <div className="ccpa-wrapper">
            <DeleteAccountSection />
            <form className="del-act-form">
              <div className="ccpa-form-row">
                <fieldset>
                  <div className="ccpa-form-col ccpa-form-col-whole">
                    <div className="ccpa-label margin-top-1">
                      <legend>Select Brand</legend>
                    </div>
                    <div className="ccpa-radio-input-group margin-top-10 height-20">
                      <div className="ccpa-radio-input position-left">
                        <input
                          type="radio"
                          id="request_7-Eleven"
                          value="7-Eleven"
                          className="text-bold"
                          onChange={this.handleSelectBrandChange}
                          checked={
                            this.state.selectedBrand ===
                            "7-Eleven"
                          }
                        />
                        <label htmlFor="request_7-Eleven">7-Eleven</label>
                      </div>
                      <div className="ccpa-radio-input position-left margin-left-3">
                        <input
                          type="radio"
                          id="request_speedway"
                          value="speedway"
                          className="text-bold"
                          onChange={this.handleSelectBrandChange}
                          checked={
                            this.state.selectedBrand === "speedway"
                          }
                        />
                        <label htmlFor="request_speedway">Speedway</label>
                      </div>
                    </div>
                    {/* <div className="ccpa-label margin-top-1 clear-both height-60">
                      <span className="seven-eleven-bg position-left"></span>
                      <span className="logo-text">7-Eleven: Rewards & Shopping</span>
                    </div>
                    <div className="ccpa-label clear-both height-60">
                      <span className="seven-now-bg position-left"></span>
                      <span className="logo-text">7NOW: Food Delivery & Alcohol</span>
                    </div> */}
                    <div className="ccpa-form-col ccpa-form-col-whole clear-both  margin-top-2">
                      <div className="ccpa-label">
                        <label
                          className={
                            this.state.formData.firstName.length > 0
                              ? ""
                              : "visiblity-hidden"
                          }
                          htmlFor="FirstName"
                          aria-label="First Name"
                        >
                          First Name
                        </label>
                      </div>
                      <div className="ccpa-input">
                        <input
                          type="text"
                          id="FirstName"
                          value={this.state.formData.firstName}
                          onChange={this.handleFirstNameChange}
                          placeholder="First Name"
                        />
                      </div>
                      <div className="ccpa-message"></div>
                    </div>
                    <div className="ccpa-form-col ccpa-form-col-whole clear-both">
                      <div className="ccpa-label margin-top-3">
                        <label
                          className={
                            this.state.formData.lastName.length > 0
                              ? ""
                              : "visiblity-hidden"
                          }
                          htmlFor="LastName"
                          aria-label="Last Name"
                        >
                          Last Name
                        </label>
                      </div>
                      <div className="ccpa-input">
                        <input
                          type="text"
                          id="LastName"
                          value={this.state.formData.lastName}
                          onChange={this.handleLastNameChange}
                          placeholder="Last Name"
                        />
                      </div>
                      <div className="ccpa-message"></div>
                    </div>
                    <div className="ccpa-form-col ccpa-form-col-whole clear-both">
                      <div className="ccpa-label margin-top-3">
                        <label
                          className={
                            this.state.formData.identifierValue.length > 0
                              ? ""
                              : "visiblity-hidden"
                          }
                          htmlFor="identifierValue"
                          aria-label="Contact Phone"
                        >
                          Contact Phone
                        </label>
                      </div>
                      <div className="ccpa-input">
                      {this.state.formData.identifierValue.length >0 && (
                          <span className="phone-watermark">+1</span>
                        )}
                        <input
                          type="text"
                          className={this.state.formData.identifierValue.length >0 ? 'phoneNum' : ''}
                          name="telphone"
                          maxlength="10"
                          title="Ten digits code"
                          required
                          value={this.state.formData.identifierValue}
                          onChange={this.handlePhoneChange}
                          placeholder="Phone number that we can use to contact you"
                        />
                      </div>
                    </div>
                    <div className="ccpa-form-col ccpa-form-col-whole clear-both">
                      <div className="ccpa-label margin-top-3">
                        <label
                          className={
                            this.state.formData.contactEmail.length > 0
                              ? ""
                              : "visiblity-hidden"
                          }
                          htmlFor="EmailAddress"
                          aria-label="Email Address"
                        >
                          Email Address
                        </label>
                      </div>
                      <div className="ccpa-input">
                        <input
                          type="text"
                          id="EmailAddress"
                          value={this.state.formData.contactEmail}
                          onChange={this.handleEmailChange}
                          placeholder="Email address that we can use to contact you"
                        />
                      </div>
                      <div className="ccpa-message">
                        <p role="alert" className="ccpa-error">
                          {this.state.emailError}
                        </p>
                      </div>
                    </div>
                    <div className="ccpa-form-col ccpa-form-col-whole clear-both">
                      <div className="ccpa-label margin-top-3">
                        <label
                          className={
                            this.state.formData.requestDetails.length > 0
                              ? ""
                              : "visiblity-hidden"
                          }
                          htmlFor="RequestDetails"
                          aria-label="Request Details"
                        >
                          Request Details
                        </label>
                      </div>
                      <div className="ccpa-textarea">
                        <textarea
                          className="margin-top-5"
                          id="RequestDetails"
                          maxLength="5000"
                          value={this.state.formData.requestDetails}
                          onChange={this.handleRequestDetailsChange}
                          placeholder="Request Details (Optional)"
                        />
                      </div>
                      <div
                        id="requestDetails_lengthCount"
                        className="position-right"
                      >
                        <span> {this.state.reqDetailsCount}</span>
                        <span>/5000</span>
                      </div>
                      <div className="ccpa-message"></div>
                    </div>
                  </div>
                </fieldset>
                <div className="ccpa-form-row position-center clear-both">
                  <button
                    type="button"
                    id="submit-button"
                    className="margin-top-3"
                    disabled={this.state.disabled}
                    onClick={this.onSubmitBtnClick}
                  >
                    Close Account
                  </button>
                  <div className="ccpa-message"></div>
                </div>
              </div>
            </form>
          </div>
        </div> :
        this.state.requestReceived ?
          <EmailConfirmation /> :
          this.state.duplicateRequest ?
            <DuplicateRequest
              duplicateRequestMsg={this.state.duplicateRequestMsg}
            /> : <InternalServerError />
    );
  }
}

export default DeleteAccountForm;



// WEBPACK FOOTER //
// src/components/DeleteAccountForm.js